import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import ServiceProviderContactAppResource from "./ServiceProviderContactAppResource";

class ServiceProviderContactLicenseTypeAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'service-provider-contact-license-type';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'services/providers/contacts/licenses/types';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'slug',
            'title',
            'sort',
            'serviceProviderContacts',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            serviceProviderContacts: ServiceProviderContactAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {};
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            slug: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            title: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            sort: {
                presence: true,
                numericality: true,
            },
        };
    }
}

export default ServiceProviderContactLicenseTypeAppResource;
